const CM_PACKAGE_SHORT_NAME = 'CM';
const PRO_PACKAGE_SHORT_NAME = 'PRO';
const CA_PACKAGE_SHORT_NAME = 'CA';
const PFO_PACKAGE_SHORT_NAME = 'PFO';
const MEMBERSHIPS_WITH_LANDING_PAGE: string[] = [PRO_PACKAGE_SHORT_NAME, CA_PACKAGE_SHORT_NAME];

export {
  CA_PACKAGE_SHORT_NAME,
  CM_PACKAGE_SHORT_NAME,
  PRO_PACKAGE_SHORT_NAME,
  PFO_PACKAGE_SHORT_NAME,
  MEMBERSHIPS_WITH_LANDING_PAGE,
};
